import React from 'react';
export function Section({
  children,
  className = '',
  id,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'default' | 'alt';
}) {
  const bgClass = variant === 'alt' ? 'bg-brand-bgAlt' : '';
  return <section id={id} className={bgClass} data-id="element-176" data-mp="2vyvmunhz9bs9">
      <div className={`py-16 md:py-24 px-4 max-w-6xl mx-auto ${className}`} data-id="element-177" data-mp="2r5sswe9ag0bj">
        {children}
      </div>
    </section>;
}